import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormioComponent } from '@formio/angular';
import { AppointmentForm } from '@models/forms/appointment-form';
import { ClinicForm } from '@models/forms/clinic-form';
import { SharedForm } from '@models/forms/shared-form';
import { PatientFormService } from '@services/patient-form.service';
import { AnyForJSON } from 'formiojs';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-form-viewer',
  templateUrl: './form-viewer.component.html',
  styleUrls: ['./form-viewer.component.less'],
})
export class FormViewerComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('formView') formView: FormioComponent;
  @Input() form: ClinicForm | AppointmentForm | SharedForm;
  @Input() submission?: string;
  @Input() patientFormId: number;
  @Input() editable: boolean;
  @Input() modalView: boolean;
  @Input() refreshViewer?: Observable<ClinicForm | AppointmentForm | SharedForm>;

  @Output() submitted: EventEmitter<any> = new EventEmitter();
  @Output() changed: EventEmitter<any> = new EventEmitter();

  patientId: number;
  formObj: AnyForJSON;
  submissionObj: AnyForJSON;
  unsub: Subject<void> = new Subject<void>();

  constructor(private route: ActivatedRoute, private patientFormService: PatientFormService) {}

  ngOnInit() {
    if (Object.keys(this.route.snapshot.params).length > 0) {
      this.patientId = +this.route.snapshot.params.patId.split('_')[0];
    }

    if (this.patientFormId && this.patientId) {
      this.patientFormService
        .getPatientFormById(this.patientFormId)
        .pipe(takeUntil(this.unsub))
        .subscribe((patientForm) => {
          this.form = patientForm.clinicForm;
          this.submission = patientForm.formEntry;
          this.initViewer();
        });
    }

    this.refreshViewer?.pipe(takeUntil(this.unsub)).subscribe((form) => {
      this.form = form;
      this.initViewer();
    });

    this.initViewer();
    this.preventScrollingInSignatureCanvas();
  }

  private initViewer() {
    // Initialize an empty instance
    this.formObj = { components: [] };
    this.submissionObj = {};

    if (this.form) {
      if (this.form.formDefinition && this.form.formDefinition !== '')
        this.formObj = JSON.parse(this.form.formDefinition);
    }

    if (this.submission && this.submission !== '') {
      this.submissionObj = JSON.parse(this.submission);
    }
  }

  private preventScrollingInSignatureCanvas() {
    // Prevent scrolling when touching the canvas
    const canvases = document.getElementsByClassName('signature-pad-canvas');
    for (let i = 0; i < canvases.length; i++) {
      canvases[i].addEventListener(
        'touchstart',
        function (e) {
          e.preventDefault();
        },
        { passive: false }
      );
      canvases[i].addEventListener(
        'touchend',
        function (e) {
          e.preventDefault();
        },
        { passive: false }
      );
      canvases[i].addEventListener(
        'touchmove',
        function (e) {
          e.preventDefault();
        },
        { passive: false }
      );
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['form'] || changes['editable'] || changes['submission']) {
      this.initViewer();
    }
  }

  onFormChange(event: any) {
    if (event?.data) {
      this.changed.emit(event);
    }
  }

  onSubmit(event: any) {
    this.submitted.emit(event);
  }

  onDomChange(event) {}

  submit(data) {
    this.formView.submit.next(data);
  }

  ngOnDestroy() {
    this.unsub.next();
    this.unsub.complete();
  }
}
